import { render, staticRenderFns } from "./modal-agents-for-promoter.vue?vue&type=template&id=6161c3ea"
import script from "./modal-agents-for-promoter.vue?vue&type=script&lang=js"
export * from "./modal-agents-for-promoter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports